import React, { useEffect, useRef, useState } from "react";

import { Outlet, useNavigate } from "react-router-dom";
import { LoadingPage } from "util/component/Loading";

import { useSelector, useDispatch, Provider } from "react-redux";

import { userAuthCF } from "util";

import axios from "util/axios";

import ModalPortal from "util/component/Modal";
import { SessionModal } from "util/component/Modal/Modal";

import { Cookies, useCookies } from "react-cookie";

const cookies = new Cookies();

let tmFunc = null;

const Maintenance = (props) => {

    return (
        <section className={"maintenance"}>
            <div>
                <h1>Maintenance</h1>
                <h3 style={{ fontWeight: "normal" }}>Until {props.description} KST</h3>
            </div>
        </section>
    );
};


const SessionCheck = () => {
    const [view, setView] = useState(null);

    const tmoverFunc = useRef(null);

    const onConfirm = async (tmout) => {
        cookies.set("bpl_login", `${new Date().toISOString()}|${tmout}`, { path: "/" })

        await axios.post(process.env.REACT_APP_API + "/session/check", {})
        clearTimeout(tmoverFunc.current);
        closeView();
    }

    const closeView = () => {
        setView(null);
    }

    const timeover = () => {
        const cookie = cookies.get("bpl_login");
        let now, tmout, lastAccess;
        
        setView(null)

        try {
            tmout = parseInt(cookie.toString().split("|")[1]) || 60;
            now = new Date();
            lastAccess = new Date(cookies.get('bpl_login')?.toString().split("|")[0]);
            lastAccess.setSeconds(lastAccess.getSeconds() + tmout - process.env.REACT_APP_SESSION_TMOUT);
            if(now > lastAccess) {
                window.location.replace("/logout")
            }

        } catch (e) {
            window.location.replace("/logout")
        }
    }

    const action = () => {
        const cookie = cookies.get("bpl_login");
        let now = new Date();
        let tmout, lastAccess;

        try {
            tmout = parseInt(cookie.toString().split("|")[1]) || 60;
            lastAccess = new Date(cookie.toString().split("|")[0]);
        } catch (e) {
            tmout = 120;
            lastAccess = new Date();
        }
        
        clearInterval(tmFunc);
        tmFunc = setInterval(() => {
            now = new Date();
            lastAccess = new Date(cookies.get('bpl_login')?.toString().split("|")[0]);
            lastAccess.setSeconds(lastAccess.getSeconds() + tmout - process.env.REACT_APP_SESSION_TMOUT);
            
            if (now > lastAccess && !view) {
                clearInterval(tmFunc);
                setView(<ModalPortal>
                    <SessionModal onConfirm={() => onConfirm(tmout)} />
                </ModalPortal>)
            }

        }, 1000);
    }

    
    clearInterval(tmFunc);
    if (view) {
        clearTimeout(tmoverFunc.current);
        clearInterval(tmFunc);
        tmoverFunc.current = setTimeout(() => {
            timeover();
        }, process.env.REACT_APP_SESSION_TMOUT * 1000)
    }
    action();

    return view;
}



const AuthRoute = () => {
    const [userLoading, setUserLoading] = useState(<LoadingPage />);
    const userSelector = useSelector((store) => store.user);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const sessionChk = async () => {
            const Response = await axios
            .post(process.env.REACT_APP_API + "/session/check", {
                userId: userSelector.userId || "",
            })
            .catch(e => window.location.href = "/error/500")
            
            if (Response.data?.code === '401') {
                const referrer = document.referrer;

                if (referrer?.match(process.env.REACT_APP_ISSUER.replace(/^http[s]?\:\/\/([a-zA-Z\-\.]+\.okta\.com)$/, '$1'))) {
                    navigate("/login", { state: { type: "okta" } })
                } else {
                    navigate("/login");
                }
            } else {
                const data = Response.data.data;
                const user = data.user;
                user.userAuth = user.userAuth ? JSON.parse(user.userAuth).map(e => {
                    return { code: e.toString() }
                }) : []
                dispatch({ type: "LOGIN", ...user, ...userAuthCF(user.userAuth), tmout: data.sessionData?.sessionMaxTime || 0 })

                setUserLoading(<Outlet />)
                // axios.get("/maintenance.json")
                //     .then(Res => {
                //         if (Res.data) {
                //             setUserLoading(<Maintenance {...Res.data} />)
                //         } else {

                //         }
                //     })
            }
        }
        sessionChk();
        
    }, []);
    return <>
        <SessionCheck />
        {userLoading}
    </>
};

export default AuthRoute;
